import React, { useMemo } from 'react';

import { useSmartLinkContext } from '@atlaskit/link-provider/use-smart-link-context';
import { SmartCardContext } from '@atlaskit/link-provider/context';

import { type RovoChatXpcContextValues } from './getRovoChatXpcContextValues';

type RovoChatXpcContextOverrideProps = RovoChatXpcContextValues & {
	children: React.ReactNode;
};

export const RovoChatXpcContextOverride = ({
	bridgeProduct,
	xpcProduct,
	xpcSubProduct,
	children,
}: RovoChatXpcContextOverrideProps): React.JSX.Element => {
	const smartLinkContext = useSmartLinkContext();

	const smartCardContextValue = useMemo(
		() => ({
			...smartLinkContext,
			bridgeProduct,
			xpcProduct,
			xpcSubProduct,
		}),
		[smartLinkContext, bridgeProduct, xpcProduct, xpcSubProduct],
	);

	return (
		<SmartCardContext.Provider value={smartCardContextValue}>{children}</SmartCardContext.Provider>
	);
};
